// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 30px;
  min-width: 300px;
  max-width: 500px;
}

.loading-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.spinner-container {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-message {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  text-align: center;
  line-height: 1.4;
}

.loading-detail {
  margin: 0 0 20px 0;
  font-size: 13px;
  color: #666;
  text-align: center;
  line-height: 1.4;
  word-break: break-word;
  max-width: 100%;
}

.progress-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.progress-bar-wrapper {
  width: 100%;
  height: 8px;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: #1976d2;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

::ng-deep .mat-dialog-container {
  padding: 0 !important;
  overflow: hidden;
}

::ng-deep .mat-progress-spinner circle {
  stroke: #1976d2;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/loading-modal/loading-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".loading-modal-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 30px;\n  min-width: 300px;\n  max-width: 500px;\n}\n\n.loading-modal-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.spinner-container {\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loading-message {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  font-weight: 500;\n  color: #333;\n  text-align: center;\n  line-height: 1.4;\n}\n\n.loading-detail {\n  margin: 0 0 20px 0;\n  font-size: 13px;\n  color: #666;\n  text-align: center;\n  line-height: 1.4;\n  word-break: break-word;\n  max-width: 100%;\n}\n\n.progress-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.progress-bar-wrapper {\n  width: 100%;\n  height: 8px;\n  background-color: #e0e0e0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-bar {\n  height: 100%;\n  background-color: #1976d2;\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  font-size: 14px;\n  color: #666;\n  font-weight: 500;\n}\n\n::ng-deep .mat-dialog-container {\n  padding: 0 !important;\n  overflow: hidden;\n}\n\n::ng-deep .mat-progress-spinner circle {\n  stroke: #1976d2;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
